import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "report-merge-modal",
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "report-merge-modal-title",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "report-merge-modal-title"
}, " Merge Reports ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Source Ref", -1)
const _hoisted_11 = { class: "col-sm-9" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Target Ref", -1)
const _hoisted_14 = { class: "col-sm-9" }
const _hoisted_15 = { class: "modal-footer" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary mr-auto",
  "data-dismiss": "modal"
}, "Cancel", -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "modal-body" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", null, "Warning", -1)
const _hoisted_20 = { class: "lead" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<p> You can only merge if: </p><ul><li>The <strong>Invoice Report</strong> has no Rooms in it.</li><li>The <strong>Rooms Report</strong> has no Invoice information in it.</li></ul><p> During the merge: </p><ul><li>The <strong>Rooms from the Rooms Report</strong> will be copied <strong>into the Invoice Report</strong>.</li><li>No reports will be deleted.</li></ul>", 4)

import { computed, ref, inject, onMounted, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import { Report } from '@/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportMergeModal',
  setup(__props) {

const instance = getCurrentInstance();
const actProperty: any = inject('actProperty');

const store = useStore();
const toasted = useToast();


const reportsState = computed(() => store.state.reports);
const mergeSource = computed({
  get: () => reportsState.value.mergeSource,
  set: (value: Report | null) => setMergeSource(value)
});

const mergeSourceRef = computed(() => mergeSource.value?.ref);

const mergeTargetRef = computed({
  get: () => reportsState.value.mergeTargetRef,
  set: (value: string) => setMergeTargetRef(value)
});

const setMergeSource = async (report: Report | null) => store.commit('reports/setMergeSource', report);
const setMergeTargetRef = async (ref: string) => store.commit('reports/setMergeTargetRef', ref);
const getReports = async () => store.dispatch('reports/getReports');
const mergeReports = async () => store.dispatch('reports/mergeReports');

const step = ref(1);

const reset = () => {
  step.value = 1;
  setMergeTargetRef('');
  instance?.proxy?.$forceUpdate();
};

const confirmMerge = () => {
  var refRegExp = new RegExp('^[0-9]+$');
  if (!mergeSource.value) {
    toasted.error(`Source Report has not been set`);
  } else if (!refRegExp.test(mergeSource.value.ref.toString())) {
    toasted.error(`Source Ref must only contain numbers`);
  } else if (!refRegExp.test(mergeTargetRef.value)) {
    toasted.error(`Target Ref must only contain numbers`);
  } else {
    step.value = 2;
    instance?.proxy?.$forceUpdate();
  }
};

const merge = async () => {
  mergeReports()
    .then(() => getReports())
    .then(() => {
      toasted.success(`Merged ${mergeSource.value?.ref} with ${mergeTargetRef.value}`);
    })
    .catch((err: any) => actProperty.displayError(err));
};

onMounted(() => reset());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", { class: "modal-header" }, [
          _hoisted_4,
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: reset
          }, _hoisted_6)
        ]),
        (step.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mergeSourceRef).value = $event)),
                      readonly: ""
                    }, null, 512), [
                      [
                        _vModelText,
                        mergeSourceRef.value,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mergeTargetRef).value = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        mergeTargetRef.value,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _withModifiers(confirmMerge, ["stop"])
                }, "Merge")
              ])
            ]))
          : _createCommentVNode("", true),
        (step.value === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("p", _hoisted_20, [
                  _createTextVNode(" Merge "),
                  _createElementVNode("strong", null, _toDisplayString(mergeSourceRef.value), 1),
                  _createTextVNode(" with "),
                  _createElementVNode("strong", null, _toDisplayString(mergeTargetRef.value), 1),
                  _createTextVNode("? ")
                ]),
                _hoisted_21
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary mr-auto",
                  onClick: reset,
                  "data-dismiss": "modal"
                }, "Cancel"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  "data-dismiss": "modal",
                  onClick: merge
                }, "OK, Merge")
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})